/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetColorSystemsQueryVariables = Types.Exact<{
  productQuery: Types.Scalars['String'];
  country: Types.CountryCode;
  language: Types.LanguageCode;
}>;


export type GetColorSystemsQuery = { __typename?: 'QueryRoot', products: { __typename?: 'ProductConnection', nodes: Array<{ __typename?: 'Product', title: string, handle: string, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', url: string }> }, cadColorOpacity?: { __typename?: 'Metafield', value: string } | null, sku?: { __typename?: 'Metafield', value: string } | null, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'Collection', handle: string, title: string }> } }> } };

export declare const getColorSystems: import("graphql").DocumentNode;

export const GetColorSystemsDocument = /*#__PURE__*/ `
    query getColorSystems($productQuery: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  products(first: 30, query: $productQuery) {
    nodes {
      title
      handle
      images(first: 3) {
        nodes {
          url
        }
      }
      cadColorOpacity: metafield(namespace: "opi", key: "cad_color_opacity") {
        value
      }
      sku: metafield(namespace: "opi", key: "sku") {
        value
      }
      collections(first: 250) {
        nodes {
          handle
          title
        }
      }
    }
  }
}
    `;
export const useGetColorSystemsQuery = <
      TData = GetColorSystemsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetColorSystemsQueryVariables,
      options?: UseQueryOptions<GetColorSystemsQuery, TError, TData>
    ) =>
    useQuery<GetColorSystemsQuery, TError, TData>(
      ['getColorSystems', variables],
      fetcher<GetColorSystemsQuery, GetColorSystemsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetColorSystemsDocument, variables, options),
      options
    );

useGetColorSystemsQuery.getKey = (variables: GetColorSystemsQueryVariables) => ['getColorSystems', variables];
;

useGetColorSystemsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetColorSystemsQueryVariables, options?: RequestInit['headers']) => fetcher<GetColorSystemsQuery, GetColorSystemsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetColorSystemsDocument, variables, options);